module.exports = __webpack_public_path__ + "img/leyIngresoMunicipal.b4816f75.jpg";